import { graphql } from 'GQL/gql';

const MarketOpportunitySkillsTypeFields = graphql(`
  fragment MarketOpportunitySkillsTypeFields on MarketOpportunitySkillsType {
    __typename
    mostRelevant {
      ...OpportunitySkillFields
    }
    relevant {
      ...OpportunitySkillFields
    }
  }
`);
MarketOpportunitySkillsTypeFields.mainFragmentName = 'MarketOpportunitySkillsTypeFields';

const MarketOpportunityFields = graphql(`
  fragment MarketOpportunityFields on MarketOpportunity {
    __typename
    _id
    job {
      _id
      name
      trendIcon
    }
    covered
    follow
    matching {
      ...MarketOpportunitySkillsTypeFields
      related {
        ...OpportunitySkillFields
      }
    }
    missing {
      ...MarketOpportunitySkillsTypeFields
    }
  }
`);
MarketOpportunityFields.mainFragmentName = 'MarketOpportunityFields';

export { MarketOpportunityFields, MarketOpportunitySkillsTypeFields };
